module.exports = __webpack_public_path__ + "img/03.b8de616a.jpg";